import { RESET_STATE } from 'src/redux/actions';
import { responseHandlerActionTypes } from './responseHandlerTypes';

const { RESPONSE } = responseHandlerActionTypes;

const intialState = {
	onResponse: {
		isToaster: false,
		severity: '',
		message: '',
	},
};

export const responseHandlerReducers = (
	state = intialState,
	{ type, payload }
) => {
	switch (type) {
		case RESPONSE:
			return { ...state, onResponse: payload };
		case RESET_STATE:
			return intialState;
		default:
			return state;
	}
};
